import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export async function callApi(): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/ExternalLogo`;

	return axios.delete(url);
}
